const content = {
  "search-device": {
    content:
      "Tap this button to search for your Explore Li+ hearing aids. Ensure Bluetooth is enabled on your device, and the hearing aids are powered on and in pairing mode.",
    title: "Search Device",
  },

  "sound-control": {
    content:
      "Tap this button to open the sound control settings, where you can adjust volume, fine-tune frequencies, and enable features like noise cancellation and whistle suppression for a personalized listening experience.",
    title: "Sound Control",
  },
  "hearing-eval": {
    content:
      "Start a hearing evaluation to assess your hearing levels and automatically adjust your hearing aids for optimal performance. Make sure you're in a quiet environment and wearing your hearing aids before beginning the test.",
    title: "Hearing Evaluation",
  },
  "vol-mode": {
    content:
      "Open the volume control settings to adjust the sound levels of your Bluetooth-connected hearing aids for a personalized listening experience.",
    title: "Volume Mode",
  },

  left: {
    content: "Adjust volume and settings for the left hearing aid.",
    title: "Left",
  },
  right: {
    content: "Adjust volume and settings for the right hearing aid.",
    title: "Right",
  },
  both: {
    content:
      "Control volume and settings for both hearing aids simultaneously.",
    title: "Both",
  },
  "vol-up": {
    content: "Increase the volume for clearer and louder sound.",
    title: "Volume Up",
  },
  "vol-down": {
    content: "Decrease the volume for softer and quieter sound.",
    title: "Volume Down",
  },
  "mpo-down": {
    content:
      "Lower the Maximum Power Output (MPO) to reduce the maximum sound level allowed.",
    title: "Mpo Down",
  },
  "mpo-up": {
    content:
      "Raise the Maximum Power Output (MPO) to increase overall sounds and reduce limitations on how loud the hearing aids can become in any environment.",
    title: "Mpo Up",
  },
  switch: {
    content:
      "Choose between Quiet, Noise and Outdoor programs depending upon your listening environment.",
    title: "Mode Switch",
  },
  "frequency-mode": {
    content:
      "Open the frequency control page to adjust and customize sound frequencies for optimal hearing clarity.",
    title: "Frequency Mode",
  },
  "freq-left": {
    content: "Adjust frequency for the left hearing aid.",
    title: "Frequency Left",
  },
  "freq-right": {
    content: "Adjust frequency for the right hearing aid.",
    title: "Frequency Right",
  },
  "mode-selection": {
    content:
      "Select your current environment to automatically optimize hearing aid settings for the best listening experience.",
    title: "Environment Select",
  },
  extra: {
    content:
      "Open advanced settings to toggle whistle suppression and noise cancellation features on or off.",
    title: "Other",
  },
};
const parentContainer = document.querySelector(".interactive-img__wrapper");
const touchPoints = document.querySelectorAll(".touch-points");
const toolTip = document.querySelector(".touchpoint-tooltip-container");
const toolTipContent = document.querySelector(".touchpoint-tooltip-content");
const tooltipTitle = document.querySelector(".touchpoint-tootlip-title");
const closeBtn = document.querySelector(".close-tooltip");

let initialScrollPosition = 0;
const threshold = 200;
const close = () => {
  touchPoints.forEach((touch) => touch.classList.remove("active-touch-point"));
  toolTip.style.display = "none";
  window.removeEventListener("scroll", handleScroll);
};
closeBtn.addEventListener("click", close);

touchPoints.forEach((tp) => {
  tp.addEventListener("click", (e) => {
    const id = e.target.id;
    const data = content[id];

    const elementPosition = e.target.getBoundingClientRect();
    touchPoints.forEach((touch) =>
      touch.classList.remove("active-touch-point")
    );
    e.target.classList.add("active-touch-point");
    toolTip.style.display = "block";
    toolTipContent.textContent = data["content"];
    tooltipTitle.textContent = data["title"];
    initialScrollPosition = window.scrollY;
    window.addEventListener("scroll", handleScroll);
  });
});

const handleScroll = () => {
  const currentPosition = window.scrollY;
  const scrollDistance = Math.abs(currentPosition - initialScrollPosition);
  // console.log(currentPosition);
  // console.log(scrollDistance);
  if (scrollDistance > threshold) {
    close();
  }
};
